import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavNotificationsInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || text_colorTextSecondary}
      fillRule="evenodd"
      d="M10 3.027c.137 0 .255.05.342.127h-.683A.509.509 0 0 1 10 3.027Zm0-1.5c-1.087 0-2 .865-2 1.97v.014a5.752 5.752 0 0 0-3.75 5.393v.636c0 .416-.126.823-.36 1.166l-1.952 2.858c-.718 1.051.034 2.477 1.307 2.477H6.84a3.191 3.191 0 0 0 3.101 2.44h.12a3.191 3.191 0 0 0 3.101-2.44h3.594c1.273 0 2.025-1.426 1.308-2.477l-1.953-2.858a2.068 2.068 0 0 1-.36-1.166v-.636c0-2.473-1.56-4.58-3.75-5.393v-.014c0-1.105-.913-1.97-2-1.97ZM5.75 8.904a4.25 4.25 0 0 1 8.5 0v.636c0 .718.217 1.42.622 2.012l1.952 2.858c.013.02.015.033.016.042a.09.09 0 0 1-.011.044.089.089 0 0 1-.03.034.077.077 0 0 1-.044.01H3.245a.077.077 0 0 1-.044-.01.09.09 0 0 1-.03-.034.09.09 0 0 1-.01-.044c0-.009.002-.022.015-.042l1.952-2.858A3.568 3.568 0 0 0 5.75 9.54v-.636Zm4.19 8.077a1.69 1.69 0 0 1-1.515-.94h3.15a1.69 1.69 0 0 1-1.515.94h-.12Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavNotificationsInactive
